import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';
import PublicNav from '../components/PublicNav';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function ForgotPassword() {
  const { getAppName } = useConfig();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to process request');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-container forgot-password-page">
        <PublicNav />
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-logo">{getAppName()}</h1>
            <p className="auth-subtitle">Check your email</p>
          </div>

          <div className="success-message" style={{ textAlign: 'center', padding: '2rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📧</div>
            <p style={{ marginBottom: '1rem' }}>
              If an account exists with <strong>{email}</strong>, we've sent password reset instructions.
            </p>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Check your inbox and spam folder. The link expires in 1 hour.
            </p>
          </div>

          <div className="auth-footer">
            <p>
              <Link to="/login">Back to login</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container forgot-password-page">
      <PublicNav />
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-logo">{getAppName()}</h1>
          <p className="auth-subtitle">Reset your password</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <p style={{ marginBottom: '1.5rem', color: '#666' }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>

          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              autoComplete="email"
              autoFocus
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block btn-lg"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Remember your password?{' '}
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
